import { ElectronApi } from '@/services/electron.api';
import { zipDir } from '../fs/zip.utils';

export const getZipBlob = async (watchfacePath: string) => {
  const allowFiles = [
    'uidmap.map',
    'description.xml',
    'resource.bin',
    'capability.json',
    'editor.config.json',
    'hashCode',
    'resources',
    'preview'
  ];
  return (await zipDir(watchfacePath, 'blob', (filename: string) => {
    const fs = ElectronApi.fs;
    const path = ElectronApi.path;
    if (!fs || !path) return false;
    const basename = path.basename(filename);
    const dirname = path.dirname(filename);

    // 文件在根目录下
    if (dirname == watchfacePath) {
      // 判断文件是否允许或者是json文件
      return allowFiles.includes(basename) || filename.endsWith('.json');
    } else {
      // 非根目录下，此时应该是preview或resource目录下的文件了
      // 这时只需要将bin文件去除掉即可，其他文件暂时不处理
      // lua或js文件夹中的.bin文件暂时不处理
      if (
        filename.endsWith('.bin') &&
        !dirname.includes(path.join('resources', '_lua')) &&
        !dirname.includes(path.join('resources', '_js'))
      ) {
        return false;
      }
    }
    return true;
  })) as Blob;
};
